import { Link, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { APP_LOGIN_URL } from "../lib/config";

export function MarketingFrame() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="unsub-site" id="top">
      <header className="unsub-header">
        <div className="unsub-shell unsub-header-inner">
          <Link className="unsub-brand" to="/" aria-label="Emails Unsubscriber home">
            <span className="unsub-mark" aria-hidden="true">U</span>
            Emails Unsubscriber
          </Link>
          <nav className="unsub-nav" aria-label="Primary navigation">
            <a className="unsub-nav-link" href="/#how-it-works">How it works</a>
            <a className="unsub-nav-link" href="/#pricing">Pricing</a>
            <Link className="unsub-nav-link" to="/articles">Guides</Link>
            <a className="unsub-nav-link" href="/#privacy">Privacy</a>
            <a className="unsub-button unsub-button-small" href={APP_LOGIN_URL}>
              Open Emails Unsubscriber <span aria-hidden="true">→</span>
            </a>
          </nav>
        </div>
      </header>

      <main><Outlet /></main>

      <footer className="unsub-footer">
        <div className="unsub-shell unsub-footer-inner">
          <span>© {new Date().getFullYear()} Emails Unsubscriber</span>
          <span className="unsub-footer-links">
            <Link to="/articles">Inbox cleanup guides</Link>
            <span className="unsub-footer-status">
              <span className="unsub-status-dot" />App available at app.emailsunsubscriber.com
            </span>
          </span>
        </div>
      </footer>
    </div>
  );
}
